import apiClient from "./apiClient";

export const getTemplates = () => {
	return apiClient.get("/Templates/GetTemplates");
};

export const sendTemplateApi = async ({ phones, templateName, templateText }) => {
	const res = await apiClient.post("/Templates/SendTemplate", {
		phones,
		templateName,
		templateText,
	});

	return res.data;
};
